import { combineReducers } from 'redux'
import { readerReducer } from './readerReducer'
import { privacyPolicy } from './privacyPolicy'
import { dropdownReducer } from './dropdownReducer'
import { userDataReducer } from './userDataReducer'
import { appearenceReducer } from "./appearenceReducer";
import { socketReducer } from "./socketReducer";

const reducer = combineReducers({
  reader: readerReducer,
  privacyPolicy: privacyPolicy,
  activeDropdown: dropdownReducer,
  userData: userDataReducer,
  appearence: appearenceReducer,
  socket: socketReducer
})

export default reducer


// WEBPACK FOOTER //
// ./src/reducers/index.js